import React from 'react';
import { Input } from 'antd';
import { useSentEmailListingStore } from '../store';

export default function ReceiverSearchBox() {
  const { setReceiver, receiver } = useSentEmailListingStore();
  return (
    <Input
      className="input-small"
      placeholder="Search by receiver..."
      value={receiver}
      onChange={e => setReceiver(e.target.value)}
    />
  );
}
